<template>
    <div :class="className" class="bg-image__container">
        <div :class="className + '-img'" class="bg-image">
            <img :src="image" alt="Background Image">
        </div>
        <div class="bg-image__txt-box">
            <div v-html="text" class="bg-image__txt"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            className: String,
            image: String,
            text: String
        }

    }
</script>
